<app-home-header></app-home-header>

<app-home-featured-units mode="featured"></app-home-featured-units>
<app-home-featured-units mode="rent"></app-home-featured-units>
<app-home-featured-units mode="sale"></app-home-featured-units>
<app-home-projects></app-home-projects>
<app-home-top-areas></app-home-top-areas>
<app-home-how-does-stay-at-work></app-home-how-does-stay-at-work>

<app-home-our-customers-say></app-home-our-customers-say>
<app-download-the-app-now></app-download-the-app-now>
<app-home-report></app-home-report>